// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_DARK_ELVES = [{
  id: 'dark_elves_slavery',
  factionId: FACTIONS.DARK_ELVES,
  name: 'Клейматор каменоломни',
  priceNumens: 6000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.ORANGE,
  ]
}, {
  id: 'dark_elves_night',
  factionId: FACTIONS.DARK_ELVES,
  name: 'Ночной каратель',
  priceNumens: 32000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'dark_elves_priestess',
  factionId: FACTIONS.DARK_ELVES,
  name: 'Паучья жрица',
  priceNumens: 75000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.PURPLE,
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.PINK
  ]
}, {
  id: 'dark_elves_gold_legacy',
  factionId: FACTIONS.DARK_ELVES,
  name: 'Аметистовый князь',
  priceNumens: 120000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'dark_elves_ruby_legacy',
  factionId: FACTIONS.DARK_ELVES,
  name: 'Тиран подземья',
  priceCrystals: 450,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.VIOLET,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
